<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" class="menu_btn" @click="$router.push('/login')">
                        <img src="@/assets/common/hd_prev_btn.png" alt="" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <p class="page_title">아이디 찾기</p>
                <form action="#n" method="post" id="user_form">
                    <div class="input_wrap">
                        <div class="input_box">
                            <span class="ico"><img src="@/assets/user/form_ico3.png" /></span>
                            <input type="text" v-model="state.name" placeholder="이름" />
                        </div>
                        <div class="input_box">
                            <span class="ico"><img src="@/assets/user/form_ico4.png" /></span>
                            <div class="info_input_box">
                                <input type="text" v-model="state.phone" placeholder="전화번호" />
                                <span class="input_info">숫자만 입력</span>
                            </div>
                        </div>
                    </div>
                    <div class="mini_submit_btn">
                        <button type="button" id="submit_btn" @click="findId">찾기</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose">
    </ModalComponent>
</template>

<script lang="ts" config>
import { reactive, router, ModalComponent, apiService, res } from "@/BaseComponent";

export default {
    props: {},
    components: { ModalComponent },
    setup() {
        const state = reactive({
            name: "" as string,
            phone: "" as string,
            id: "" as string,
            isModalOpen: false as boolean,
        });
        const modal = reactive({
            content: "" as string,
            confirm: "확인" as string,
            cancel: "취소" as string,
            actionCode: 0 as number
        });

        const findId = async () => {
            if (state.name && state.phone != "" && state.name && state.phone != null) {
                const res: res = await apiService.base.findId(state.name, state.phone);
                if (res.returnCode === 0) {
                    state.id = res.id;
                    state.isModalOpen = true;
                    modal.content = `해당 아이디는 <br> <a class="modal_var">[#${res.id}]</a> <br>입니다.`;
                    modal.confirm = "로그인하기";
                    modal.cancel = "";
                    modal.actionCode = 1;
                } else {
                    modal.content = res.description;
                    state.isModalOpen = true;
                }
            } else {
                state.isModalOpen = true;
                modal.content = "이름과 전화번호를 전부 입력해주세요";
                modal.confirm = "";
                modal.cancel = "확인";
            }
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.actionCode) {
                    case 1:
                        router.replace("/login");
                        break;

                    default:
                        break;
                }
            }
        };
        return {
            state,
            modal,
            router,
            findId,
            modalClose,
        };
    },
};
</script>
